import _ from 'lodash';
import  { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ApplicableTableSettings, codesVesselNameList } from '../../../../tableSettings';

import useFastStorage from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import ApplicationContext from '../../../../ApplicationContext';
import { Search, initialSearch, isFilterObjectEmpty } from '../../../../filtering';
import { Portal } from 'react-portal';
import { CodeVesselListItem } from '../../../../fms.data/models/CodeVesselListItem';
import { JobNames } from '../../../../framework.core/JobNames';
import { ApiResult, InsertResult } from '../../../../framework.core/data/ApiResult';
import { SQLType } from '../../../../framework.core/data/SQLInfo';
import { FmsSecTask } from '../../../../fms.core/constants';
import GreenButton from '../../../../ui/GreenButton';
import TextBox from '../../../../ui/TextBox';
import EditableTable, { CellData, EditableTableHandle, TableCellAligns, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import { checkTabIsDirty, sortingListData } from '../../ReferenceFiles';
import { findSecurityTask } from '../../../../util';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";

import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import CloseButton from '../../../../ui/CloseButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';

class EditableVesselName extends CodeVesselListItem {
  isNew: boolean = false;
  isDelete: boolean = false;
  isUpdate: boolean = false;
  tested: boolean = false;
}


// function ActionRenderer({ data, row }:any) {
//   return (
//     <div style={{textAlign: 'left', marginLeft: '10px'}}>
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Cancel"
//         
//         onClick={() => data[row.index].isNew ? data[row.index].onDelete() : data[row.index].requestOperationCancel()}
//       >
//         <FontAwesomeIcon icon={faTimes} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       <PrimaryInverseButton
//         disabled={data[row.index].editIndex !== row.index}
//         style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//         data-tooltip="Save"
//         
//         onClick={() => data[row.index].onSave()}
//       >
//         <FontAwesomeIcon icon={faSave} />
//       </PrimaryInverseButton>&nbsp;&nbsp;
//       {!data[row.index].isNew && data[row.index].listSec?.grantDel &&
//         <>
//           <PrimaryInverseButton
//             disabled={data[row.index].editIndex !== row.index}
//             style={{fontSize: '14px', lineHeight: '14px', margin: '0', padding: '0'}}
//             data-tooltip="Delete"
//             
//             onClick={() => data[row.index].onDelete()}
//           >
//             <FontAwesomeIcon icon={faTrashAlt} />
//           </PrimaryInverseButton>
//         </>
//       }
//     </div>
//   );
// }

function VesselNameRenderer({data, row, cell}:any) {

  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];

  /**
  async function checkDuplicateVesselName(newValue:string) {
    if (l.tested && l.vesselName === newValue) {
      return true;
    }

    if (l.cid === newValue) {
      changeLineItem(row.index, { tested: true });
      return true;
    }

    if (await appContext.api.checkupDuplicateFieldValueIsDuplicate("T_CODEVESSEL", "F_VesselName", newValue.trim())) {
      await showGlobalOkDialog(<p>You didn't enter a duplicate Vessel Name.</p>);
      return false;
    }
    else
      changeLineItem(row.index, { tested: true });

    return true;
  }
   */

  return (
    <TextBox
      maxLength={50}
      textId={`ifms-vesselname-name-${row.index}`}
      value={l.vesselName}
      onChange={(e) => {
        changeLineItem(row.index, { vesselName: e.target.value, isUpdate: true, tested: false });
      }}
      // onBlur={async (e) => {
      //   return await checkDuplicateVesselName(e.target.value);
      // }}
    />
  );
}


function CountryRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={2} textId="ifms-sdk-country" value={l.country} onChange={(e) => {
        changeLineItem(row.index, {country: e.target.value, isUpdate:true });
        
        }} />
    </div>
  );
}

function VesselFlagRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;  
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={2} textId="ifms-sdk-vessel-flag" value={l.vesselFlag} onChange={(e) => {
          changeLineItem(row.index, {vesselFlag: e.target.value, isUpdate:true });
        }} />
    </div>
  );
}

function LloydsRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={7} textId="ifms-sdk-lloyds" value={l.lloydsCode} onChange={(e) => {
       changeLineItem(row.index, {lloydsCode: e.target.value, isUpdate:true });
        }} />
    </div>
  );
}

function GroupRenderer({data, row, cell}:any) {
  const changeLineItem = data[0].changeLineItem;
  const l = data[row.index];
  return (
    <div style={{marginTop: '0px'}}>
      <TextBox maxLength={7} textId="ifms-sdk-group" value={l.groupName} onChange={(e) => {
       changeLineItem(row.index, {groupName: e.target.value, isUpdate:true });
        }} />
    </div>
  );
}

function formatElement(data:any) {
  const result = new EditableVesselName();
  result.vesselName = data.vesselName;
  result.country = data.country;
  result.vesselFlag = data.vesselFlag;
  result.lloydsCode = data.lloydsCode;
  result.groupName = data.groupName;
  result.cid = data.cid;
  result.isNew = false;
  result.isDelete = false;

  return result;
}

function formatData(data: Array<any>) {
  return data.map(d => formatElement(d));
}

function VesselNameComponent({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({
    invokers: {
      ifmsReferenceFilesSave: save,
      ifmsReferenceFilesCancel: cancelOperation,
    }
  });
  useFunctionKeys({ onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  //const { selectTableRow } = useTableNavigation('codes-vessel-name-list', undefined, undefined, [], false, true, true);

  const tableRef = useRef(null);
  const masterTableRef = useRef<EditableTableHandle>(null);

  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState(Array<String>());
  const [hasChanges, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-vessel-name-list`, []);

  const savedDataRef = useRef<Array<CodeVesselListItem>>([]);
  const oriData = useRef<CodeVesselListItem[]>([]);
  //const addingToTheFirstLine = useRef(false);

  //const [, , , ediRef] = useFastStorage(`ifms-referenceFiles-vessel-name-editindex`, -1);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-vessel-name-orderby`, {
    orderBy: 'vesselName',
    orderByAscending: true,
    //general1: 'VesselName',
    //generalText1: '',     //<pt220816>
    //pageSize: systemSettings.defaultPageSize,
  });

  const listSec = findSecurityTask(appContext, FmsSecTask.CodeVessel);
  const tableHeight = 520;
  const listItemType = 'CodeVesselListItem';

  const [focusFirstCell, setFocusFirstCell] = useState(true);
  const { FilterButton, search } = useFilterBar(
    codesVesselNameList,
    undefined,
    getDefaultOrderBy,
    String(componentIndex)
  );

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelector('[class^="ReactModal__Content"]');
      if (!modals)
        saveBtn.click();
    }
  }

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'vesselName',
      orderByAscending: true,
    };
  }

  function setData(d: any, callByFetchData: boolean = false) {
    setFocusFirstCell(callByFetchData);
    _setData(d, null, { forceClone: callByFetchData });
    setHasChanges(checkTabIsDirty(CodeVesselListItem, oriData.current, d));
  }

  async function fetchData(api: any, search: Search) {
    setLoading(true);

    const searchModel = CodeVesselListItem.calculateSearchParameters(search);
    const apiResult = await api.getListItems(JobNames.Vessel,
      listItemType,
      searchModel, 1, search.pageSize);

    setData(formatData(apiResult && apiResult.entities ? apiResult.entities : []), true);
    setOrderBy(getDefaultOrderBy());

    setFocusFirstCell(false);
    setLoading(false);
    setHasChanges(false);
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);
    
    return () => {
      removeData();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, search);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      //selectTableRow(0);
      oriData.current = _.cloneDeep(data);
      savedDataRef.current = _.cloneDeep(data);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function reload(clearAll:boolean = true) {
    const searchValue = clearAll ? initialSearch : search;
    await fetchData(appContext.api, searchValue);
  }

  function onHeaderClick(header: any) {
    // if (ediRef.current !== -1) {
    //   return;
    // }

    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
    }

    removeData();
    sortingListData(CodeVesselListItem, data, setData, orderBy);
  }

  // async function requestOperationCancel() {
  //   const doCancel = await showGlobalYesNoDialog(<p>Are you sure you want to cancel Edit operation</p>);
  //   if (doCancel) {
  //     cancelOperation(false)
  //   } else {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80);
  //   }
  // }

  // async function onRowIndexChanged(rowIndex:number) {
  //   if (rowIndex < 0 && ediRef.current >= 0) {
  //     setTimeout(() => {
  //       selectTableRow(ediRef.current);
  //     }, 80)
  //     return;
  //   }

  //   if (ediRef.current >= 0 && ediRef.current !== rowIndex) {
  //     await requestOperationCancel();
  //   }
  // }

  // function onRowSelect(rowIndex:number) {
  //   if (rowIndex >= 0 && rowIndex < dataRef.current.length && _.isEmpty(inlineElement) && (listSec?.grantEdit || listSec?.grantDel)) {
  //     setHasChanges(true);
  //     inlineElement = {...dataRef.current[rowIndex], isNew: false};
  //     setEi(rowIndex);
  //   }
  // }

  // function selectForNew() {
  //   inlineElement = {
  //     vesselName: '', country: '', vesselFlag: '', lloydsCode: '', groupName: '', isNew: true,
  //   };
  //   data.unshift(inlineElement);
  //   setData(data);
  //   setEi(0);
  //   setHasChanges(true);
  // }

  // function addingLineToFirstLine(){
  //   addingToTheFirstLine.current = true;
  //   masterTableRef.current?.add();
  // }

  function addLineItem() {
    let newrow = new EditableVesselName();
    newrow.isNew = true;

    return {
      setDataFunc: (list: any) => setData(list),
      curListData: data,
      newData: newrow
    };
  }

  async function cancelOperation(){
    setHasChanges(false);
    removeData();
    return true;
  }
/*
  function getIndexOfFirstInvalidCell(rowIndex: number){
    if(!data) return undefined;

    if(!data[rowIndex].vesselName){
      return 1;
    }
    if (allData) { //기존데이터 목록
      const newData = [...allData];
      if(newData.filter(x => x === data[rowIndex].vesselName.toLowerCase()).length === 0) // 현재 목록에 없음
      {
        newData.splice(rowIndex, 1, data[rowIndex].vesselName.toLowerCase());
        setAllData(newData);
        return undefined;
      }else{
        if(newData[rowIndex] === data[rowIndex].vesselName.toLowerCase()) return undefined;
        else{
          showGlobalOkDialog(<p>'{data[rowIndex].vesselName}' is a duplicate value.</p>);
          return 1;
        }
      }
    } 
    else {
      const newData = [data[rowIndex].vesselName.toLowerCase()];
      setAllData(newData);
    }
    return undefined;
  }
*/

  function applyToLineItem(rowIndex: number, change: Partial<EditableVesselName>|null) {
    if (!change || !data) {
      return;
    }
    const checkData = data[rowIndex];
    if (!change.isNew && (change.vesselName !== checkData.vesselName || change.country !== checkData.country
      || change.vesselFlag !== checkData.vesselFlag|| change.lloydsCode !== checkData.lloydsCode|| change.groupName !== checkData.groupName)) {
    _.merge(data[rowIndex], {...change, hasBeenChanged: true});
    setData(data);
    //setHasChanges(true);
    }
    return true;
  }

  function deleteEntity(rowIndex: number): boolean {
    if (!data) {
      return false;
    }

    const element = data[rowIndex];
    if (!element.isNew) {
      let deleteRow = savedDataRef.current.find(x => x.vesselName === element.vesselName);
      if (deleteRow) {
        deleteRow.isDelete = true;
        //setHasChanges(true);
      }
    }
    data.splice(rowIndex, 1);
    setData(data);

    const tempData = data.map((a: CodeVesselListItem) => a.vesselName.toLowerCase());
    const newData = allData.splice(0, tempData.length, tempData);
    setAllData(newData);

    return true;
  }

  async function duplicateCell(checkData: any) {
    let duplicateFieldText = '';

    let isDuplicate = false;
    let insList = checkData.filter((x: any) => x.isNew === true);
    let chgList = checkData.filter((x: any) => x.hasBeenChanged === true && !x.isNew);
    let focusRow = -1;

    if (!data) return isDuplicate;

    if (insList.length > 0 && data.length > 0) {
      for (let i = 0; i < insList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (insList[i].vesselName.toUpperCase() === data[j].vesselName.toUpperCase()) {
            if (count === 0) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${insList[i].vesselName}' is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (chgList.length > 0 && data.length > 0) {
      for (let i = 0; i < chgList.length; i++) {
        let count = 0;
        let tempRow = -1;
        for (let j = 0; j < data.length; j++) {
          if (chgList[i].vesselName.toUpperCase() === data[j].vesselName.toUpperCase()) {
            if (data[j].hasBeenChanged === true && !data[j].isNew && tempRow === -1) { tempRow = j; }
            count++;
            if (count > 1) {
              if (focusRow === -1) focusRow = tempRow;
              break;
            }
          }
        }
        if (count > 1) {
          duplicateFieldText += `'${chgList[i].vesselName} is a duplicate value.\r\n`;
          isDuplicate = true;
        }
      }
    }

    if (!isDuplicate) {
      const apiResult = await appContext.api.checkDuplicatedKeys(JobNames.Vessel, listItemType, insList, chgList);
      if (apiResult && apiResult.success && apiResult.message) {
        duplicateFieldText = `${apiResult.message}`;
        isDuplicate = true;
      } else if (!apiResult || !apiResult.success) {
        await showGlobalOkDialog('Could not check duplication.\r\nPlease try later.');
        return true;
      }
    }
    else
      await showGlobalOkDialog(`${duplicateFieldText}Please try after correcting duplication.`);

    return isDuplicate;
  }
/**
function checkValidVesselName() {
  if (data === null) return;

  let validData = dataRef.current.filter((x:any) => x.vesselName);
  setData(validData);
}
 */

  async function save() {
    if (!data) {
      return;
    }

    // checkValidVesselName();
    let validData = dataRef.current.filter((x:any) => x.vesselName);

    let errMsg = '';
    const dataToSave = validData.filter((x: any) => x.id <= 0 || x.hasBeenChanged === true); // new data is always last so index check works
    const dataToDelete = savedDataRef.current.filter((x) => x.isDelete);
    if(dataToSave.length === 0 && dataToDelete.length === 0) {
      if (hasChanges) reload(false);
      return;
    }
    setLoading(true);

    for (let i = 0; i < dataToDelete.length; ++i) {
      const s = dataToDelete[i];
      const apiResult: ApiResult<InsertResult> = await appContext.api.saveListItem(listItemType,
        SQLType.Delete,
        _.omit(s, ['isDelete']));

      if (!apiResult || !apiResult.success)
        errMsg = apiResult.message?? constants.SAVE_ERROR_MESSAGE;
    }

    if (dataToSave.length > 0) {
      const isDuplicate = await duplicateCell(dataToSave);
      if(isDuplicate){
        setLoading(false);
        return;
      }
      const cidData = dataToSave.map((a: CodeVesselListItem) => a.cid?.toLowerCase()) as Array<String>;

      const secondSave = dataToSave.filter((x: CodeVesselListItem) => cidData.includes(x.vesselName.toLowerCase()));
      const firstSave = dataToSave.filter((x: CodeVesselListItem) => !secondSave.includes(x));

      if (firstSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, firstSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE );
        else {
          firstSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.vesselName === x.vesselName);
            if (index >= 0) {
              data[index].cid = x.vesselName;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              x.isNew = false;
              //delete data[index].isNew;
            }
          })
        }
      }
      if (secondSave.length > 0) {
        const apiResult: ApiResult<InsertResult> = await appContext.api.saveList(listItemType, secondSave);
        if (!apiResult || !apiResult.success)
          errMsg += (errMsg ? '\n' : '') + (apiResult?.message ?? constants.SAVE_ERROR_MESSAGE);
        else {
          secondSave.forEach((x: any) => {
            const index = data.findIndex((d: any) => d.vesselName === x.vesselName);
            if (index >= 0) {
              data[index].cid = x.vesselName;
              data[index].hasBeenChanged = false;
            }
            if (x.isNew) {
              x.isNew = false;
              //delete data[index].isNew;
            }
          })
        }
      }
    }
    
    if(errMsg) {
      await showGlobalOkDialog(<p>{errMsg}</p>);
      setLoading(false);
      return;
    }
    // setData(data);
    // savedDataRef.current = _.cloneDeep(data);
    // oriData.current = _.cloneDeep(data);

    // setLoading(false);
    // setHasChanges(false);
    reload(false);

    await showGlobalOkDialog(<p>The data has been saved</p>);
  }

  
  const tableOptions: ApplicableTableSettings = {
    customTableId: 'codes-vessel-name-list',
    ref: tableRef,
    selectable: true,
    tableName: 'vesselNameList',
    ...codesVesselNameList,
    height: `${tableHeight}px`,
    //data: data.map((x:any, i:number) => ({...x, indicator: (i + 1).toString(), editIndex: ei, onDelete: deleteEntity, onSave: save, onCancel: cancelOperation, setHasChanges, requestOperationCancel, listSec})),
    data: (data ?? []).map((x: any, i: number) => ({ ...x, indicator: (i + 1).toString(), changeLineItem: applyToLineItem })),
    rowRenderers: [
      { accessor: 'indicator' },
      { accessor: 'vesselName', EditCell: VesselNameRenderer },
      { accessor: 'country', EditCell: CountryRenderer },
      { accessor: 'vesselFlag', EditCell: VesselFlagRenderer },
      { accessor: 'lloydsCode', EditCell: LloydsRenderer },
      { accessor: 'groupName', EditCell: GroupRenderer },
      // { accessor: 'action', Cell: ActionRenderer },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      if (accessor === 'vesselName')
        return { type: TableCellTypes.Text, value: data[rowIndex].vesselName  };
      else if (accessor === 'country')
       return { type: TableCellTypes.Text, value: data[rowIndex].country, align: TableCellAligns.Center };
      else if (accessor === 'vesselFlag')
        return { type: TableCellTypes.Text, value: data[rowIndex].vesselFlag, align: TableCellAligns.Center};
      else if (accessor === 'lloydsCode')
        return { type: TableCellTypes.Text, value: data[rowIndex].lloydsCode, align: TableCellAligns.Center};
      else if (accessor === 'groupName')
        return { type: TableCellTypes.Text, value: data[rowIndex].groupName, align: TableCellAligns.Center};
      else
        return undefined;
    },
    isCellLock: (accessor: string, rowData: any): boolean => {
      if(!(listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel))
        return true
      else
        return false;
    },
    orderBy: [orderBy],
    onHeaderClick,
    useEditControls: (listSec?.grantAdd || listSec?.grantEdit || listSec?.grantDel),
  };

  //const canSelectForNew = ei === -1;
  const canBeAdd = listSec?.grantAdd;

  return (
    <div style={{ marginTop: '40px' }}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Ocean <FontAwesomeIcon icon={faAngleRight} />&nbsp;Vessel Name</h1>
        <div style={{width: '320px', fontWeight: 'bold'}}>
        
        </div>
      </Portal> */}
      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{display:'flex', marginTop:'5px'}}>
          <div className="ifms-common-bar-element">
            <GreenButton size="regular" disabled={loading} onClick={save}>Save</GreenButton>
          </div>
          <div className="ifms-common-bar-element ifms-left-separator-light-gray">
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
          {/* <div className="ifms-common-bar-element">
            <BlackInverseButton name='list-screen-refresh' size="large" style={{marginTop: '-5px'}} disabled={loading} onClick={reload} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div> */}
        </div>
      </Portal>

      {/* <div style={{ width: '320px', fontSize: '11px', fontWeight: 'bold' }}>
        <ClearableSearch
          initialValue={orderBy?.generalText1 || ''}
          onSearch={async generalText1 => {
            await reload(generalText1 === null ? '' : generalText1);
          }}
        />
      </div> */}
      <div style={{ display: 'flex', width: '864px' }}>
        <div style={{ marginLeft: 'auto' }}></div>

        <div style={{ position: 'relative', top: '-4px' }}>
          <div style={{ display: 'none' }}>
            <FilterButton /> &nbsp;&nbsp;
          </div>
          {//<SecondaryButton name='codes-vessel-name-add-button' size="regular" disabled={!canBeAdd} onClick={() => { addingLineToFirstLine() }}><FontAwesomeIcon icon={faPlus} />&nbsp; Add Line</SecondaryButton> &nbsp; 
          }
          <BlackInverseButton name='list-screen-refresh' size="large" disabled={loading} onClick={() => { reload(false); }} data-tooltip="Refresh" >
            <FontAwesomeIcon color='#47C83E' icon={faSync} />
          </BlackInverseButton>
        </div>
      </div>
      <div style={{ width: '864px'}}>
      {/* <SmartTable {...tableOptions} />  */}
      <EditableTable
        initializeFocusedCell={focusFirstCell}
        ref={masterTableRef}
        tableOptions={tableOptions}
        deleteLine={deleteEntity}
        addLine={addLineItem}
        //getIndexOfFirstInvalidCell = {getIndexOfFirstInvalidCell}
        canDeleteRow={rowNumber => listSec?.grantDel??false}
      />
    </div>
    </div>
  );
}

export default VesselNameComponent;
